import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_COMMISSION_LOG,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'commissionlog' })
export default class CommissionLog extends VuexModule {
  @Action
  FetchComissionLog(username) {
    return Vue.axios({
      url: BASE_URL + FETCH_COMMISSION_LOG,
      data: username,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
